<script setup>
import { computed } from 'vue'

import HazardPopover from '@/components/hazard/HazardPopover.vue'

const props = defineProps({
  id: { type: String, required: true },
  isShown: { type: Boolean, default: false },
  hazardData: {
    type: Object,
    default: () => ({
      score: null,
      authority: null,
      details: null,
    }),
  },
})

const hazardClasses = computed(() => ({
  'table-secondary': props.hazardData.score === 'I',
  'table-warning-light': props.hazardData.score === 'M',
  'table-success': props.hazardData.score === 'L',
  'table-danger': props.hazardData.score === 'VH',
  'table-orange': props.hazardData.score === 'H',
  'authoritative': props.hazardData.authority === 'Authoritative',
  'screening': props.hazardData.authority === 'Screening',
  'predicted': props.hazardData.authority === 'QSAR Model',
}))
</script>

<template>
  <div
    :id="id"
    class="rounded-sm"
    :class="isShown ? hazardClasses : ''"
    style="display: grid; padding: 0 0.1rem"
  >
    <div
      style="
        visibility: hidden;
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.8rem;
        grid-row-start: 1;
        grid-column-start: 1;
        cursor: help;
      "
    >
      VH
    </div>
    <div
      v-if="isShown"
      style="
        color: rgba(0, 0, 0, 0.6);
        font-size: 0.8rem;
        grid-row-start: 1;
        grid-column-start: 1;
        cursor: help;
        text-align: center;
        align-self: center;
      "
      @click.self.stop
    >
      {{ hazardData.score }}
      <HazardPopover
        :target="id"
        :hazard-chemical="hazardData.details"
        first-only
      />
    </div>
  </div>
</template>
